export default function PastTrials() {
  return <h1>PastTrials</h1>;
}
